import React from "react";
import { NodeProps, useEdges, useNodes } from "reactflow";
import { operationType } from "../../../../../services/types";
import { Main, Styled } from "./style";
import { SettingsBlock, settingsDataType } from "../../../../settingsBlock";
import { IoCheckmarkCircleOutline, IoWarningOutline } from "react-icons/io5";
import { ExpandedBlock } from "../../../expanded";

type PDFChunkerProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function PDFChunker({ id, data, setChildMinimize, setChildSettings }: PDFChunkerProps) {
   const nodes = useNodes();
   const edges = useEdges();
   // eslint-disable-next-line react-hooks/exhaustive-deps
   const fileBlock = React.useMemo(() => nodes.find(node => (node.data as any).outputTypeSub === 'fileURL' && edges.some(edge => edge.target === id && edge.source === node.id)), [edges])
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);
   
   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // ---
   const isWarning = !fileBlock;

   return (<>
      <SettingsBlock nodeId={ id }data={ settings } setData={ setSettings } />
      <Main>
         { isWarning ? <>
            <div id="warning"></div>
            <span id="warningIcon"><IoWarningOutline size={21} /></span>
         </> : data.output ? <>
            <div id="ran"></div>
            <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
         </> : null}
         { isExpanded ? <ExpandedBlock
            data={{ id, ...data }} 
            handleClose={ () => setIsExpanded(false) } 
            isWarning={ isWarning }
            style={{ width: '350px' }}
         ><Styled>
            <div className="status">
               { fileBlock ? <div>
                  <span></span>
                  <span>{ (fileBlock.data as any).index }</span> 
               </div>
               : <span className="empty">No blocks connected</span>}
            </div>
            {/* { data.value?.log?.length ? <ul className="log">{
               data.value.log.map((log: string, index: number) => (<li key={ index.toString() }>{ log }</li>))
            }</ul> : null } */}
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}